/* Carrito lateral "Winner" */
(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer || !drawer.classList.contains('pw-cart')) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2);
  }

  /* ---------- Eliminar producto (icono papelera) ---------- */
  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pw-remove]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('.cart__item');
    if (item) item.style.opacity = '.4';
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: btn.dataset.pwRemove, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    });
  });

  /* ---------- Temporizador de reserva ---------- */
  var timer = drawer.querySelector('[data-pw-timer]');
  if (timer) {
    var total = (+timer.dataset.minutes || 5) * 60 * 1000;
    var KEY = 'pwCartTimerEnd';
    function getEnd() {
      var end = 0;
      try { end = +sessionStorage.getItem(KEY) || 0; } catch (e) {}
      if (!end || end < Date.now()) {
        end = Date.now() + total;
        try { sessionStorage.setItem(KEY, end); } catch (e) {}
      }
      return end;
    }
    var end = getEnd();
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { end = getEnd(); left = end - Date.now(); }
      var s = Math.floor(left / 1000);
      var t = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      timer.innerHTML = timer.dataset.text.replace('[time]', '<b>' + t + '</b>');
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Barra de recompensa ---------- */
  var reward = drawer.querySelector('[data-pw-reward]');
  var products = drawer.querySelector('[data-products]');
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function updateReward(totalCents) {
    if (!reward) return;
    var goal = +reward.dataset.goal || 0;
    var left = Math.max(goal - totalCents, 0);
    var pct = goal > 0 ? Math.min(totalCents / goal * 100, 100) : 100;
    reward.querySelector('[data-pw-reward-fill]').style.width = pct + '%';
    reward.querySelector('[data-pw-reward-text]').innerHTML = left > 0
      ? esc(reward.dataset.text).replace('[amount]', '<b>' + money(left) + '</b>')
      : esc(reward.dataset.done);
  }
  if (reward) {
    updateReward(+reward.dataset.total || 0);
    if (products) {
      new MutationObserver(function () {
        var items = products.querySelector('[data-cart-subtotal]');
        if (items) updateReward(+items.dataset.cartSubtotal || 0);
      }).observe(products, { childList: true });
    }
  }
})();
